require.register("app/restaurant/analyse/InvoiceBox", function(exports, require, module){
  $0
  
});

